import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import {useSelector} from 'react-redux';

import {PROJECT_STATUS} from '../../../utils/constant';
import interventionService from '../../../services/intervention/InterventionService';

import {shouldDisplayInformationMessage} from './utils';

import InformationMessageWithActions from './InformationMessageWithActions';

/*
Display when
  Project is active
  “Grant access to the project” step has been skipped
  User has access to the project
  User has permission to manage projects
*/
const GrantAccessInformationMessage = props => {
  const organisationId = useSelector(({organisation}) => organisation.organisationId);
  const history = useHistory();

  if (
    props.myIntervention?.grantAccessUpdateDate ||
    !shouldDisplayInformationMessage(props.project)
  ) {
    return null;
  }

  const handleConfirm = () => {
    history.push(`${props.baseUrl}/user-access`);
  };

  const handleCancel = () => (
    interventionService.updateProjectUserPermissionsAlreadyDone(
      props.myIntervention.interventionId,
      {
        organisationId,
        projectId: props.project.projectId
      }
    )
  );

  return (
    <InformationMessageWithActions
      message="project.notifications.grantAccess"
      confirmMessage="project.grantAccess.button"
      cancelMessage="project.notifications.cancel"
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      onRefresh={props.onRefresh}
    />
  );
};

GrantAccessInformationMessage.propTypes = {
  myIntervention: PropTypes.shape({
    interventionId: PropTypes.number.isRequired,
    grantAccessUpdateDate: PropTypes.string
  }).isRequired,
  project: PropTypes.shape({
    projectId: PropTypes.number.isRequired,
    creationDate: PropTypes.string.isRequired,
    projectStatus: PropTypes.oneOf(Object.values(PROJECT_STATUS)).isRequired
  }).isRequired,
  baseUrl: PropTypes.string,
  onRefresh: PropTypes.func.isRequired
};

export default GrantAccessInformationMessage;
